__webpack_require__.p = "/mtg_booster_simulator/";